(function () {
  'use strict';

  /* ── Money formatting ── */

  function formatMoney(priceStr, format) {
    const amount = parseFloat(priceStr).toFixed(2);
    const amountNoDecimals = String(Math.round(parseFloat(priceStr)));
    const amountComma = amount.replace('.', ',');
    return (format || '{{amount}}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  /* ── Search query ── */

  function getSearchQuery() {
    var input = document.querySelector('[data-collection-product-search]');
    return input ? input.value.trim().toLowerCase() : '';
  }

  /* ── Dynamic search result cards ── */

  var injectedCards = [];
  var activeChipTerm = '';

  function clearInjectedCards() {
    injectedCards.forEach(function (el) { el.remove(); });
    injectedCards = [];
  }

  function buildDynamicCard(product, moneyFormat) {
    var li = document.createElement('li');
    li.className = 'grid__item collection-search-injected';

    var a = document.createElement('a');
    a.href = product.url;
    a.className = 'collection-search-card';

    if (product.cardImage) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'collection-search-card__image-wrap';
      var img = document.createElement('img');
      img.src = product.cardImage;
      img.alt = product.title;
      img.loading = 'lazy';
      img.className = 'collection-search-card__image';
      imgWrap.appendChild(img);
      a.appendChild(imgWrap);
    }

    var info = document.createElement('div');
    info.className = 'collection-search-card__info';

    var title = document.createElement('p');
    title.className = 'collection-search-card__title';
    title.textContent = product.title;
    info.appendChild(title);

    if (product.price) {
      var price = document.createElement('p');
      price.className = 'collection-search-card__price';
      price.textContent = formatMoney(product.price, moneyFormat);
      info.appendChild(price);
    }

    a.appendChild(info);
    li.appendChild(a);
    return li;
  }

  function injectSearchResults(query, chipMode) {
    clearInjectedCards();

    var grid = document.getElementById('product-grid');
    if (!grid || !allCollectionProducts || !query) return;

    var config = window.__collectionSearch || {};
    var moneyFormat = config.moneyFormat || '{{amount}}';
    var lowerQuery = query.toLowerCase();
    var terms = lowerQuery.split(/\s+/).filter(Boolean);

    var matches = allCollectionProducts.filter(function (p) {
      if (chipMode) {
        var haystack = [p.title, p.productType, p.tags].join(' ').toLowerCase();
        return terms.some(function (t) { return haystack.indexOf(t) !== -1; });
      }
      var titleHay = p.title.toLowerCase();
      return terms.every(function (t) { return titleHay.indexOf(t) !== -1; });
    });

    matches.forEach(function (product) {
      var card = buildDynamicCard(product, moneyFormat);
      grid.appendChild(card);
      injectedCards.push(card);
    });
  }

  /* ── Search filter applied to grid ── */

  function applySearchFilter() {
    var query = getSearchQuery();
    var searchActive = query.length > 0;

    var gridItems = document.querySelectorAll('#product-grid .grid__item:not(.collection-search-injected)');
    var pagination = document.querySelector('.pagination-wrapper, .pagination');

    clearInjectedCards();

    if (searchActive) {
      var chipMode = activeChipTerm !== '' && query.toLowerCase().indexOf(activeChipTerm.toLowerCase()) !== -1;
      gridItems.forEach(function (item) { item.style.display = 'none'; });
      injectSearchResults(query, chipMode);
    } else {
      gridItems.forEach(function (item) { item.style.display = ''; });
    }

    if (pagination) {
      pagination.style.display = searchActive ? 'none' : '';
    }
  }

  /* ── Collection product fetch ── */

  var allCollectionProducts = null;

  function fetchCollectionProducts(handle) {
    if (allCollectionProducts !== null) {
      return Promise.resolve(allCollectionProducts);
    }

    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        allCollectionProducts = (data.products || []).map(function (p) {
          var thumb = '';
          var cardImage = '';
          if (p.images && p.images.length > 0) {
            thumb = p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_150x$1$2');
            cardImage = p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_533x$1$2');
          }
          var tagsStr = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
          return {
            title: p.title,
            productType: p.product_type || '',
            tags: tagsStr,
            url: '/products/' + p.handle,
            image: thumb,
            cardImage: cardImage,
            price: p.variants && p.variants[0] ? p.variants[0].price : ''
          };
        });
        return allCollectionProducts;
      })
      .catch(function () {
        allCollectionProducts = [];
        return [];
      });
  }

  /* ── Autocomplete suggestions ── */

  function highlightMatch(text, query) {
    if (!query) return document.createTextNode(text);
    var idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return document.createTextNode(text);
    var frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode(text.slice(0, idx)));
    var mark = document.createElement('mark');
    mark.textContent = text.slice(idx, idx + query.length);
    frag.appendChild(mark);
    frag.appendChild(document.createTextNode(text.slice(idx + query.length)));
    return frag;
  }

  function renderSuggestions(products, query, searchInput, clearBtn, suggestionsEl) {
    suggestionsEl.innerHTML = '';

    var config = window.__collectionSearch || {};
    var moneyFormat = config.moneyFormat || '{{amount}}';

    var lowerQuery = query.toLowerCase();
    var matches = products.filter(function (p) {
      return p.title.toLowerCase().indexOf(lowerQuery) !== -1;
    }).slice(0, 8);

    if (matches.length === 0) {
      suggestionsEl.classList.remove('collection-product-search__suggestions--visible');
      return;
    }

    var heading = document.createElement('p');
    heading.className = 'collection-product-search__suggestions-heading';
    heading.textContent = 'Products';
    suggestionsEl.appendChild(heading);

    matches.forEach(function (product) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');

      var a = document.createElement('a');
      a.href = product.url;
      a.className = 'collection-product-search__suggestion';
      a.setAttribute('tabindex', '-1');

      if (product.image) {
        var img = document.createElement('img');
        img.src = product.image;
        img.className = 'col-search-thumb';
        img.alt = product.title;
        img.width = 50;
        img.height = 50;
        a.appendChild(img);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className = 'col-search-thumb-placeholder';
        a.appendChild(placeholder);
      }

      var content = document.createElement('div');
      content.className = 'col-search-content';

      var titleEl = document.createElement('p');
      titleEl.className = 'col-search-title';
      titleEl.appendChild(highlightMatch(product.title, query));
      content.appendChild(titleEl);

      if (product.price) {
        var priceEl = document.createElement('p');
        priceEl.className = 'col-search-price';
        priceEl.textContent = formatMoney(product.price, moneyFormat);
        content.appendChild(priceEl);
      }

      a.appendChild(content);
      li.appendChild(a);
      suggestionsEl.appendChild(li);
    });

    var footerLi = document.createElement('li');
    var footerBtn = document.createElement('button');
    footerBtn.type = 'button';
    footerBtn.className = 'collection-product-search__suggestion--footer';

    var footerText = document.createElement('span');
    footerText.textContent = 'Search for \u201C' + query + '\u201D';
    footerBtn.appendChild(footerText);

    var arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrowSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    arrowSvg.setAttribute('viewBox', '0 0 14 10');
    arrowSvg.classList.add('col-search-footer-arrow');
    arrowSvg.setAttribute('fill', 'none');
    arrowSvg.setAttribute('stroke', 'currentColor');
    arrowSvg.setAttribute('stroke-width', '2');
    arrowSvg.setAttribute('aria-hidden', 'true');
    var arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrowPath.setAttribute('d', 'M1 5h12M8 1l4 4-4 4');
    arrowPath.setAttribute('stroke-linecap', 'round');
    arrowPath.setAttribute('stroke-linejoin', 'round');
    arrowSvg.appendChild(arrowPath);
    footerBtn.appendChild(arrowSvg);

    footerBtn.addEventListener('mousedown', function (e) {
      e.preventDefault();
      hideSuggestions(suggestionsEl);
      applySearchFilter();
      searchInput.blur();
    });

    footerLi.appendChild(footerBtn);
    suggestionsEl.appendChild(footerLi);

    suggestionsEl.classList.add('collection-product-search__suggestions--visible');
  }

  function buildSuggestions(query, searchInput, clearBtn, suggestionsEl) {
    if (!query || query.length < 1) {
      hideSuggestions(suggestionsEl);
      return;
    }

    var config = window.__collectionSearch || {};
    var handle = config.handle;

    if (!handle) {
      var fallbackProducts = [];
      document.querySelectorAll('#product-grid [data-product-title]').forEach(function (card) {
        fallbackProducts.push({
          title: card.getAttribute('data-product-title') || '',
          url: card.getAttribute('data-product-url') || '#',
          image: card.getAttribute('data-product-image') || '',
          price: card.getAttribute('data-product-price') || ''
        });
      });
      renderSuggestions(fallbackProducts, query, searchInput, clearBtn, suggestionsEl);
      return;
    }

    fetchCollectionProducts(handle).then(function (products) {
      renderSuggestions(products, query, searchInput, clearBtn, suggestionsEl);
    });
  }

  function hideSuggestions(suggestionsEl) {
    if (suggestionsEl) {
      suggestionsEl.classList.remove('collection-product-search__suggestions--visible');
      suggestionsEl.innerHTML = '';
    }
  }

  /* ── Init ── */

  function init() {
    var config = window.__collectionSearch || {};
    if (config.handle) {
      fetchCollectionProducts(config.handle);
    }

    var searchInput = document.querySelector('[data-collection-product-search]');
    var clearBtn = document.querySelector('[data-collection-search-clear]');
    var suggestionsEl = document.querySelector('[data-collection-search-suggestions]');

    if (searchInput) {
      var debounceTimer;

      searchInput.addEventListener('input', function (event) {
        event.stopPropagation();
        var query = searchInput.value.trim();

        if (clearBtn) {
          clearBtn.classList.toggle('collection-product-search__clear--visible', query.length > 0);
        }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          applySearchFilter();
          if (suggestionsEl) {
            buildSuggestions(query, searchInput, clearBtn, suggestionsEl);
          }
        }, 250);
      });

      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          clearTimeout(debounceTimer);
          hideSuggestions(suggestionsEl);
          applySearchFilter();
          searchInput.blur();
        } else if (event.key === 'Escape') {
          hideSuggestions(suggestionsEl);
          searchInput.blur();
        }
      });

      searchInput.addEventListener('focus', function () {
        var query = searchInput.value.trim();
        if (query && suggestionsEl) {
          buildSuggestions(query, searchInput, clearBtn, suggestionsEl);
        }
      });

      document.addEventListener('click', function (e) {
        if (suggestionsEl && !searchInput.contains(e.target) && !suggestionsEl.contains(e.target)) {
          hideSuggestions(suggestionsEl);
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        activeChipTerm = '';
        if (searchInput) {
          searchInput.value = '';
          searchInput.focus();
        }
        clearBtn.classList.remove('collection-product-search__clear--visible');
        hideSuggestions(suggestionsEl);
        applySearchFilter();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
